// deps
import React, { memo, ReactNode } from "react";

// components
import { CoreLayout } from "@core-ui/components/core-layout";
import { CommonHeader } from "@core-ui/components/common-header";

interface CommonUIWrapperProps {
    content: ReactNode;
    containerCSSClass?: string;
    header: ReactNode;
    headerCSSClass?: string;
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    headerExtraContent?: React.ReactElement;
    backButtonLocator?: string;
    containerId?: string;
    isPageScrolled?: boolean;
    isDineoutCartHeader?: boolean;
    grayBackground?: boolean;
}

const CommonUIWrapper = React.forwardRef<HTMLDivElement, CommonUIWrapperProps>(
    (props: CommonUIWrapperProps, ref): React.ReactElement => {
        return (
            <CoreLayout>
                <>
                    <CoreLayout.Header isDineoutCartHeader={props.isDineoutCartHeader}>
                        <CommonHeader
                            onBack={props.onBack}
                            containerClass={props.headerCSSClass}
                            isVisible={true}
                            backButtonLocator={props.backButtonLocator}
                            grayBackground={props.grayBackground}
                        >
                            {props.header}
                            {props.headerExtraContent}
                        </CommonHeader>
                    </CoreLayout.Header>
                    <CoreLayout.Content
                        className={props.containerCSSClass}
                        ref={ref}
                        isDineoutCart={props.isDineoutCartHeader}
                    >
                        {props.content}
                    </CoreLayout.Content>
                </>
            </CoreLayout>
        );
    },
);

if (__DEV__) CommonUIWrapper.displayName = "CommonUIWrapper";

export default memo(CommonUIWrapper);
